var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      size: "mini",
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "领取人",
      prop: "c02GetStaff"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.c02GetStaff,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c02GetStaff", $$v);
      },
      expression: "form.c02GetStaff"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "领取日期",
      prop: "c02GetDate"
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      placeholder: "请选择领取日期",
      clearable: "",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.form.c02GetDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c02GetDate", $$v);
      },
      expression: "form.c02GetDate"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };